import { axiosNT} from "../../../services/axios";

export const getCoupledTestList = (queryString: string, testId: string) => {
  return axiosNT.get(`/benchmark/coupled/test-suggestions?testId=${testId}&searchQuery=${queryString}`);
}